import { DatePicker } from "antd";
import React from "react";
import { calculateAge } from "../../../../utils/helper";
import { useDispatch } from "react-redux";
import moment from "moment";
import dayjs from "dayjs";

const DOB = ({
  displayDob,
  updateDisplayDOB,
  selectedDob,
  componentType,
  updateDateOfBirth,
  handleCustomerDataFieldChange,
}) => {
  const dispatch = useDispatch();

  const handleDateChange = (value, dateString) => {
    if (componentType === "bookingDetails") {
      handleCustomerDataFieldChange("dob", value?.valueOf());
    } else {
      dispatch(
        updateDateOfBirth({
          dob: dateString,
        })
      );
    }

    dispatch(updateDisplayDOB(false));
  };

  let age = calculateAge(selectedDob);

  return (
    <div
      className="flex  items-center rounded-[12px] border-[1px] border-[#EDF1F7]  relative w-[100%] "
      onClick={(e) => {
        dispatch(updateDisplayDOB(!displayDob));
        e.stopPropagation();
      }}
    >
      <div
        onClick={(e) => {
          e.stopPropagation();
        }}
      >
        <DatePicker
          allowClear={false}
          onChange={handleDateChange}
          value={dayjs(
            Boolean(selectedDob)
              ? selectedDob
              : moment().subtract(18, "year").format("YYYY/MM/DD")
          )}
          placement="bottomRight"
          style={{
            borxder: "none",
            width: "0",
            height: "0",
            padding: "0",
            display: "hidden",
          }}
          suffixIcon={<></>}
          format={"YYYY/MM/DD"}
          open={displayDob}
          size="small"
        />
      </div>

      <div className="flex  cursor-pointer w-[70%]">
        <span className="p-2  pl-4 px-2 text-[10px] lg:text-[12px] text-[#4D4D4D] font-[400] ">
          {selectedDob
            ? dayjs(selectedDob).format("D/MM/YYYY")
            : dayjs().subtract(18, "year").format("D/MM/YYYY")}
        </span>
      </div>

      <div
        className="p-2 px-2 font-[500] w-[30%] whitespace-nowrap border-l-[1px]
        text-center border-l-[#EDF1F7]  text-[#007FFF]  text-[14px] leading-[20px] tracking-[2%]"
      >
        {selectedDob ? `${age} Yr` : "-"}
      </div>
    </div>
  );
};

export default DOB;
